import { Map, List, fromJS } from "immutable";
import { resolveEach } from "redux-resolver";
import * as actionTypes from "./actionTypes";

export const initialState = Map({
  notifications: List(),
  totalCount: 0,
  stale: false
});

export default resolveEach(initialState, {
  [actionTypes.EXPIRE]: state => state.set("stale", true),
  [actionTypes.ADD]: (state, action) =>
    state.merge({
      notifications: state
        .get("notifications")
        .splice(0, 0, fromJS(action.notification)),
      totalCount: state.get("totalCount") + 1
    }),
  [actionTypes.REMOVE]: (state, action) =>
    state.merge({
      notifications: state
        .get("notifications")
        .filter(n => n.get("id") !== action.id),
      totalCount: state.get("totalCount") - 1,
      unreadCount: state.getIn(["data", "unread_count"])
    }),
  [actionTypes.REMOVE_ALL]: (state, action) =>
    state.merge({
      notifications: state
        .get("notifications")
        .filter(n => !action.ids.includes(n.get("id"))),
      totalCount: state.get("totalCount") - action.ids.length
    }),
  [actionTypes.SET_ALL]: (state, action) =>
    state.merge({
      notifications: action.notifications,
      totalCount: action.totalCount,
      unreadCount: action.unreadCount,
      stale: false
    })
});



// WEBPACK FOOTER //
// ./app/Nav/Notifications/reducer.js